import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CompetenceOrderRuleListComponent from './CompetenceOrderRuleListComponent';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import ViewQuilt from '@mui/icons-material/ViewQuilt';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';
import { Prompt } from 'react-router-dom';

const CompetenceOrderRuleListCard = ({
  competenceOrderRules,
  approvalTypeLevels,
  ruleStatuses,
  onAdd,
  onSave,
  onPropertyChanged,
  onDelete,
  onExpandChange,
  validation
}) => {
  const { t } = useTranslation();

  return (
    <Card
      icon={ViewQuilt}
      iconColor='primary'
      title={t('CompetenceOrder.Rules')}
      actions={<IconButton type='add' fontSize='medium' color='transparent' tooltip={t('Tooltips.Add')} onClick={onAdd} />}
    >
      <CardNoResultsWrapper content={competenceOrderRules}>
        <Prompt when={competenceOrderRules.some(x=> x.changed)} message={t('CompetenceOrder.LeavingWithoutSavingRule')} />
        <CompetenceOrderRuleListComponent
          competenceOrderRules={competenceOrderRules}
          approvalTypeLevels={approvalTypeLevels}
          ruleStatuses={ruleStatuses}
          onSave={onSave}
          onPropertyChanged={onPropertyChanged}
          onDelete={onDelete}
          onExpandChange={onExpandChange}
          validation={validation}
        />
      </CardNoResultsWrapper>
    </Card>
  );
};

CompetenceOrderRuleListCard.propTypes = {
  onAdd: PropTypes.func.isRequired,
  competenceOrderRules: PropTypes.array.isRequired,
  approvalTypeLevels: PropTypes.array,
  ruleStatuses: PropTypes.array,
  onAddNewRule: PropTypes.func,
  onSave: PropTypes.func.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onExpandChange: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default CompetenceOrderRuleListCard;
